import React from 'react';
import Lottie from 'lottie-react';
import loaderAnimation from './assets/CAVU-animation.json';
import { Flex, Text, useBreakpointValue } from '@spothero/ui';
const AnimatedLoader = ({ options = {}, loaderText = '', }) => {
    const loaderOptions = {
        autoplay: true,
        animationData: loaderAnimation,
        loop: true,
        ...options,
    };
    const isMobile = useBreakpointValue({ base: true, tablet: false });
    return (<Flex data-testid="AnimatedLoader-text-container" alignItems="center" justifyContent="center" minHeight="100vh" direction="column" marginTop={isMobile
            ? '-header-height-mobile'
            : '-desktop-search-header-height-without-filters'}>
            <Lottie {...loaderOptions}/>
            {Boolean(loaderText) && (<Text data-testid="AnimatedLoader-text" textAlign="center" px="5">
                    {loaderText}
                </Text>)}
        </Flex>);
};
export default AnimatedLoader;
